module.exports = __webpack_public_path__ + "img/sign.d04ac845.png";